// LogoMarquee — CSS-animated dual-row scrolling logo showcase
import React from "react";
import { PlatformIcon } from "@/components/logos";
import { PLATFORMS } from "@/data/platforms";

const ROW_1_IDS = ["chatgpt", "gemini", "claude", "copilot", "perplexity", "grok", "meta_ai", "mistral", "deepseek", "cohere"];
const ROW_2_IDS = ["crewai", "autogen", "langchain", "langgraph", "cursor", "windsurf", "manus", "emergent", "vscode", "replit"];

function MarqueeRow({ platformIds, direction = "left", duration = 30 }) {
  const doubled = [...platformIds, ...platformIds];
  return (
    <div className="overflow-hidden relative group" style={{ maskImage: "linear-gradient(to right, transparent, black 8%, black 92%, transparent)" }}>
      <div
        className="flex gap-8 py-3 w-max group-hover:[animation-play-state:paused]"
        style={{
          animation: `marquee-${direction} ${duration}s linear infinite`,
        }}
      >
        {doubled.map((id, i) => (
          <div
            key={`${id}-${i}`}
            className="flex items-center gap-2.5 px-4 py-2 rounded-xl border border-[var(--qn-border)]/40 bg-[var(--qn-surface)]/30 opacity-60 hover:opacity-100 transition-opacity shrink-0"
          >
            <PlatformIcon platformId={id} size="sm" variant="color" />
            <span className="text-sm font-medium text-[var(--qn-foreground-muted)] whitespace-nowrap">
              {PLATFORMS.find(p => p.id === id)?.name || id}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function LogoMarquee() {
  return (
    <section className="py-16 overflow-hidden max-w-[100vw]" data-testid="logo-marquee">
      <div className="text-center mb-8">
        <p className="text-lg font-semibold text-[var(--qn-foreground)]">
          Works with the tools you already use
        </p>
        <p className="text-sm text-[var(--qn-foreground-muted)] mt-1">
          38 platforms across 10+ regions
        </p>
      </div>
      <div className="space-y-4 max-w-6xl mx-auto">
        <MarqueeRow platformIds={ROW_1_IDS} direction="left" duration={35} />
        <MarqueeRow platformIds={ROW_2_IDS} direction="right" duration={40} />
      </div>

      <style>{`
        @keyframes marquee-left {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        @keyframes marquee-right {
          from { transform: translateX(-50%); }
          to { transform: translateX(0); }
        }
      `}</style>
    </section>
  );
}
